import { render, staticRenderFns } from "./DDChooseMonthlyAmount.vue?vue&type=template&id=6ace0114&scoped=true"
import script from "./DDChooseMonthlyAmount.vue?vue&type=script&lang=js"
export * from "./DDChooseMonthlyAmount.vue?vue&type=script&lang=js"
import style0 from "./DDChooseMonthlyAmount.vue?vue&type=style&index=0&id=6ace0114&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ace0114",
  null
  
)

export default component.exports